<template>
  <el-dialog
    custom-class="theme-dialog split-line-footer-dialog no-padding-top-dialog"
    title="更多筛选条件"
    :visible.sync="visibility"
    width="824px"
    append-to-body
  >
    <div ref="container" class="condition-content overflow-y-auto px-1" style="max-height: 50vh">
      <div class="mb-1 mt-6">
        <span>符合以下</span>
        <el-select class="mx-2" style="width: 80px" v-model="anyExtra" size="small">
          <el-option :value="false" label="全部"></el-option>
          <el-option :value="true" label="任一"></el-option>
        </el-select>
        <span>条件：</span>
      </div>
      <ul>
        <li v-for="(condition, index) in conditions" :key="condition.c_id" class="flex items-center mt-4" v-show="condition.show">
          <div class="flex items-center">
            <el-select v-model="condition.type" size="small">
              <el-option
                v-for="(item) in conditionAttrs"
                :key="item.optionField"
                :value="item.optionField"
                :label="item.optionName"
              />
            </el-select>
            <template v-if="condition.type">
              <component :key="condition.type" ref="condition" :is="componentName(condition)" :data="attribute(condition)" />
            </template>
          </div>
          <el-button class="ml-3" size="dygc" :class="{ 'mr-5': hasScroll }" type="text" @click="onDeleteCondition(index)">
            删除
          </el-button>
        </li>
      </ul>
      <div class="mt-1">
        <el-button type="text" @click="onAddCondition">
          <span class="flex items-center">
            <img src="~@/assets/img/plus.png" alt="" width="14" />
            <span class="ml-1">添加筛选条件</span>
          </span>
        </el-button>
      </div>
    </div>
    <template v-slot:footer>
      <div class="flex justify-between">
        <div>
          <el-button size="small" type="text" @click="onClearAll">清空全部条件</el-button>
        </div>
        <div>
          <el-button class="normal-button" size="small" type="light-default" @click="onCancel">取消</el-button>
          <el-button class="normal-button" size="small" type="primary" @click="onSaveCondition">发起筛选</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { conditionComponent, componentMap } from '../conditions'

let c_id = 0
let searchContainerHeight = window.innerHeight / 2
export default {
  name: 'SearchCondition',
  components: { ...conditionComponent },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      conditions: [],
      anyExtra: false,
      conditionAttrs: [],
      hasScroll: false,
      attributes: []
    }
  },
  computed: {
    filterConditions() {
      return this.conditions.filter(c => c.show)
    },
    visibility: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
        if (!val) {
          this.conditions = this.conditions.filter(c => {
            c.show = true
            return !c.isNewCondition && c.type
          })

          this.anyExtra = this.oldAnyExtra
        }
      }
    },
  },
  created() {
    this.oldAnyExtra = this.anyExtra
    this.conditionAttrs = this.$store.getters.sampleFields
  },
  methods: {
    onClearAll() {
      this.conditions.filter(i => (i.show = false))
    },
    onSaveCondition() {
      try {
        let conditions = this.conditions.reduce((res, condition, index) => {
          if (condition.type && this.conditions[index].show) {
            res.push(this.getExtraParam(condition, index))
          }
          return res
        }, [])

        let searchParam = {
          anyExtra: this.anyExtra,
          extraParams: conditions
        }
        this.conditions = this.conditions.filter(c => c.show)
        this.conditions.forEach(c => (c.isNewCondition = false))
        this.oldAnyExtra = this.anyExtra
        this.$emit('search', searchParam, conditions)
        this.visibility = false
      } catch (e) {
        console.log(e.message)
        this.$message.error(e.message)
      }
    },

    onAddCondition() {
      const condition = {
        c_id: c_id++,
        type: null,
        condition: '',
        isNewCondition: true,
        show: true
      }
      this.conditions.push(condition)
    },
    onDeleteCondition(idx) {
      this.conditions[idx].show = false
    },
    onCancel() {
      this.visibility = false
    },
    changeScroll() {
      let container = this.$refs.container
      let scrollHeight = container.scrollHeight
      if (scrollHeight > searchContainerHeight) {
        this.hasScroll = true
      }
    },
    getExtraParam(condition = {}, index) {
      const condVM = Array.isArray(this.$refs.condition) ? this.$refs.condition : [this.$refs.condition];
      const { getExtraParam } = condVM[index] || {};
      const params = typeof getExtraParam === 'function' ? getExtraParam() : {};
      return Object.assign(params, {
        fieldName: condition.type || ''
      });
    },
    attribute(condition = {}) {
      return this.conditionAttrs.find(item => item.optionField === condition.type)
    },
    componentName(condition = {}) {
      let attr = this.attribute(condition) || {};
      return componentMap[attr.optionType]
    },
  },
  watch: {
    filterConditions() {
      this.$nextTick(() => {
        this.changeScroll()
      })
    }
  }
}
</script>

<style scoped></style>
